import { css } from '@emotion/core';
import { MEDIA_BREAKPOINTS } from '../../../../common/services/breakpoints';

export const filterSelectionMenuCSS = ({ colors }) => `
    display: inline-block;

    padding-left: 1rem;
    vertical-align: top;
    flex: 1;
    border-left: 0.063rem solid ${colors.neutral80};
    overflow-y: auto;
`;

export const filterSelectionMenuTopDownCSS = css`
    padding-top: 1rem;
    display: inline-block;
    width: 100%;
`;

export const clearFiltersCSS = ({ colors }) => css`
    all: unset;
    cursor: pointer;
    white-space: nowrap;

    color: ${colors.blue60};
    background-color: transparent;

    &:hover {
        text-decoration: underline;
    }

    &:active {
        text-decoration: underline;
        font-weight: bold;
    }
`;

export const clearFiltersContainerCSS = css`
    display: inline-flex;
    float: right;
    justify-content: center;
    align-items: center;
    padding-right: 0.5rem;
`;

export const clearFiltersDisabledCSS = ({ colors }) => css`
    all: unset;
    cursor: not-allowed;
    white-space: nowrap;
    padding: 0.1rem 0.5rem 0.5rem;
    float: right;
    color: ${colors.disabledLightGrey};
    background-color: transparent;
`;

export const filterNameLabelCSS = ({ colors }) => css`
    color: ${colors.textSecondary};
    font-weight: bold;
    padding-right: 0.5rem;
`;

export const filterNameContainerCSS = css`
    display: inline-block;
`;

export const filterTableFitRowCSS = css`
    width: 30%;
`;

export const filterTableCSS = css`
    padding-bottom: 1rem;
    padding-top: 1rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    th {
        text-align: justify;
        padding-bottom: 0.5rem;
    }
    tbody {
        display: block;
        width: 100%;
        tr {
            width: 100%;
            display: inline-table;
            &:not(:first-of-type) {
                padding-top: 1rem;
            }
        }
    }
`;

export const filterNumberLabelCSS = ({ colors }) => css`
    display: flex;
    width: 2rem;
    height: 2rem;
    background-color: ${colors.neutral99};
    border-radius: 50%;
    text-align: center;
    align-items: center;
    justify-content: center;
    color: ${colors.textPrimary};
`;

export const filterTableTitleCSS = ({ colors }) => css`
    font-weight: normal;
    color: ${colors.textSecondary};
`;

export const filterInputCSS = css`
    height: 2.188rem;
    width: 17.5rem;
`;

export const filterInputTopDownCSS = css`
    height: 2.188rem;
    width: 17.5rem;
    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        width: 9rem;
    }
    ${MEDIA_BREAKPOINTS.EXTRA_SMALL} {
        width: 7em;
    }
`;

export const filterRowContainerCSS = css`
    display: inline-flex;
    width: 100%;
    vertical-align: middle;
    ${MEDIA_BREAKPOINTS.EXTRA_SMALL} {
        display: flex;
        flex-wrap: wrap;
    }
`;

export const filterRowDropDownMenuCSS = css`
    padding-left: 0.5rem;
    align-items: center;
`;

export const filterTypeDropDownMenuCSS = ({ colors }) => css`
    width: 11.75rem;

    input {
        color: ${colors.black};
    }
`;

export const filterTypeOperatorCSS = css`
    padding-left: 0.75rem;
    text-align: center;
    width: 4rem;
    ${MEDIA_BREAKPOINTS.EXTRA_SMALL} {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        padding-left: 0;
        text-align: left;
    }
`;

export const filterTypeStringOperatorCSS = css`
    padding-left: 0.75rem;
    text-align: center;
    width: 4rem;
    padding-top: 0.25rem;
    ${MEDIA_BREAKPOINTS.EXTRA_SMALL} {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        padding-left: 0;
        text-align: left;
    }
`;

export const filterSelectionMenuContainerCSS = css`
    padding-left: 0.75rem;
    flex: 1;
    ${MEDIA_BREAKPOINTS.EXTRA_SMALL} {
        padding-bottom: 0.5rem;
        padding-left: 0.75rem;
        text-align: left;
    }
`;

export const filterRowPlusMinusButtonsCSS = css`
    padding-left: 0.5rem;
    display: inline-flex;
    align-self: auto;
`;

export const filterRowPlusButtonCSS = css`
    padding-right: 0.25rem;
    align-content: baseline;
`;

export const filterNumberMenuContainerCSS = css`
    display: flex;
`;

export const filterButtonsCSS = ({ colors }) => css`
    cursor: pointer;
    border-radius: 50%;
    height: 2.2rem;
    width: 2.2rem;
    border-color: transparent;
    background-color: transparent;
    padding: unset;

    &:hover,
    &:active {
        background-color: ${colors.hoverBackground};
    }

    > svg {
        color: ${colors.neutral10};
    }

    &:disabled {
        > svg {
            color: ${colors.disabledDarkGrey};
        }
        background-color: transparent;
        cursor: not-allowed;
    }
`;

export const filterSelectionMobileMenuOperatorCSS = css`
    display: flex;
    padding-left: 2.5rem;
    flex-basis: 100%;
`;

export const filterSelectionMenuMobileContainerCSS = css`
    display: flex;
    padding-left: 2.5rem;
    flex-basis: 100%;
`;

export const filterOperatorMenuCSS = css`
    width: 4rem;
`;
